<template>
  <q-page padding>   
    <p>{{ $t('global.Login') }}</p>
    <hr>
   <q-field  
      :label="$t('global.AccountNumber')"
      helper="Ihre Kunden Nummer"
      error-label="Ihre Kunden Nummer"
    >
    <q-input type="text" ref="customerid" v-model="form.idCustomer" @keyup.enter="login"  />
  </q-field> 
  <q-field  
      :label="$t('global.UserName')"
  >
    <q-input type="text" ref="userName" v-model="form.userName" @keyup.enter="login"  />
  </q-field>
  <q-field  
      :label="$t('global.Password')"
    >
    <q-input type="password" v-model="form.password" @keyup.enter="login" />
  </q-field>
  <hr>
  <q-btn type="submit"  color="primary"  label="Login" @click="login" :loading="submitting" />
  <div v-if="$org == 2 || $org == 4">
    <hr>
      <q-btn type="submit"  color="secondary"  label="ACCESO ADMIN" @click="openAdmin" />
  </div>
</q-page>
</template>
<script>
import { Cookies } from 'quasar'
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'
//import { required, email } from 'vuelidate/lib/validators'
export default {
  name: 'Login',
  data: function () {
    return {
      alert: false,
      submitting: false,
      form: {
        idCustomer: null,
        userName: '',
        password: '',
        email: '',
        password: '',
        action: 'Login'
      },
      userData: {
        email: '',
        password: '',
        action: 'Login'
      }
    }
  },
  validations: {
    form: {}
  },
  methods: {
    login () {
      this.submitting = true
      var d = new Date();
      var n = d.getTimezoneOffset();
      this.form.TimezoneOffset = n
            axios.post(this.$apiUrl,
            qs.stringify(this.form),
            {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            })
            .then(response => {
                this.submitting = false
                console.log(response.data)
                console.log(response)
                if(response.status == 200){ 
                    if(response.data.Status == 1){
                      Cookies.set('idCustomer', this.form.idCustomer, { expires: 100 })
                      this.form.Culture = response.data.Culture
                      this.form.StartLatitude = response.data.StartLatitude
                      this.form.StartLongitude = response.data.StartLongitude
                      this.form.StartZoomLevel = response.data.StartZoomLevel
                      this.form.MapTypeId = response.data.MapTypeId
                      this.form.UtcOffset = response.data.UtcOffset
                      this.form.SessionId = response.data.SessionId
                      this.form.CustomerName = response.data.CustomerName
                      this.form.Login = response.data.Login
                      this.form.Admin = response.data.Admin
                      
                      if(this.form.Culture == "de-DE"){
                        this.form.DateFormat = "DD.MM.YYYY"
                        this.form.DateTimeFormat = "DD.MM.YYYY HH:mm"
                      }
                      else{
                        this.form.DateFormat = "MM/DD/YYYY"
                        this.form.DateTimeFormat = "MM/DD/YYYY HH:mm"
                      }
                      
                      this.$store.dispatch('setSession', this.form)
                      this.$i18n.locale = response.data.Culture.substr(0,2)

                      if(this.form.Culture == "de-DE"){
                      var lang = 'de'
                        import(
                          /* webpackInclude: /(de|en-us|es|th)\.js$/ */
                          `quasar/lang/${lang}`
                          ).then(lang => {
                          this.$q.lang.set(lang.default)
                        })
                      }

                      if(this.org == 1)
                        this.$router.push({name: 'Map'})
                      else
                        this.$router.push({name: 'GeneralDashboard'});      
                      
                      /* Theo 19.6.2020 took that out and changed map.vue to interval load on mounted
                      setTimeout(function() { 
                        window.dispatchEvent(new Event('resize')) 
                        eventBus.$emit('login', null)
                        }, 250);  
                      */
                    }
                    else{
                        this.$q.notify({ message: 'Wrong Credentials, please review fields again.', type: 'negative'})
                    }
                }
                else{
                    this.$store.dispatch('setSession', null)
                    this.$q.notify('Something Wrong.')
                }
            })
            .catch(e => {
                this.submitting = false
                if(e.response.status == 403){
                    //this.errors.push(this.translate('LoginError'))
                    this.$q.notify('Something Wrong.')
                }
                console.log(e);
                this.$store.dispatch('setSession', null)
            })
    },
    openAdmin(){
      if (this.$org == 4)
        location.replace('https://admin.gpsturix.com')
      else
        location.replace('https://admin.rastrealo.com')
    }

  },
  mounted: function () {
            this.form.idCustomer = Cookies.get('idCustomer')
            if(this.$org == 2 || this.$org == 4){ //set Rastrealo to Spanish
              this.$i18n.locale = 'es'
            }
            if(this.$org == 3){ //set Infinitrack to Thai
              this.$i18n.locale = 'th'
            }
    },
}
</script>
